module.exports = __webpack_public_path__ + "static/chief_guh-5edb457eb29bda0021994c51962c5b90.jpeg";